import React from 'react';
import { Link } from 'react-router-dom';

import '../styles/depositPP.css'
import CurrencyConverter from '../../others/templates/CurrencyConverter';

const DepositPP = ({ depositPP, setDepositPP, depositValue, setDepositGG, account }) => {
  const handleSub = (e) => {
    e.preventDefault();
    setDepositPP(false)
    setDepositGG(true)
  }
  return (
    <>
      <div className={"depositPP " + (depositPP ? ' showSummary' : ' hideSummary')}>
        <div className="container">
          <ul>
            <li><h3>Currency: </h3><p>{depositValue.currency} {depositValue?.network}</p></li>
            <li><h3>Amount: </h3><p>
              < CurrencyConverter
                currency={account?.currency}
                amount={depositValue?.amount}
              /></p>
            </li>
            <li><h3>Charges: </h3><p>
              +< CurrencyConverter
                currency={account?.currency}
                amount={depositValue.charges}
              />{ }</p>
            </li>
            <li><h3>Payable: </h3><p>
              +< CurrencyConverter
                currency={account?.currency}
                amount={depositValue.payable}
              /></p>
            </li>
            <p><Link onClick={handleSub} className='btn-hover'>Confirm</Link></p>
            <h4 onClick={(e) => setDepositPP(false)} className='btn-hover'>Cancel</h4>
          </ul>
        </div>
      </div>
    </>
  )
}

export default DepositPP